import React from 'react';
import { NavLink } from 'react-router-dom';
import { appMenu } from './../static-data/';
import SocialButtons from './SocialButtons';

const AppMenu = () => (
    <div className="header__app-menu">
        <ul className="app-menu">{
            appMenu.map(item =>
                (<li className="app-menu__item" key={item.url}>
                    <NavLink
                        activeClassName="app-menu__link_active"
                        className="app-menu__link"
                        to={item.url}
                    >{item.name}</NavLink>
                </li>)
            )
        }</ul>
        <SocialButtons />
    </div>
);

export default AppMenu;



// WEBPACK FOOTER //
// ./src/components/AppMenu.jsx